import React, { useContext } from "react";

import { classes } from "@bloomberg/media-ui-core";
import { useFortress } from "@foundation/fortress";
import styles from "./companyInfo.module.css";
import About from "~components/About";
import { QuoteContext } from "~context/QuoteContext";
import BoardMembersContainer from "~components/BoardMembersContainer";
import Executives from "~components/Executives";
import { getFortressState } from "~utils/getFortressState";
import TopHoldings from "~components/TopHoldings";
import { TopHolding } from "~types/types";

export default function CompanyInfoContainer() {
  const quoteData = useContext(QuoteContext);

  const fortressContext = useFortress();
  const { isAllowed } = getFortressState(fortressContext);

  // TODO: have 500 page if none of quote data is returning;

  if (!quoteData) {
    return null;
  }
  const {
    boardMembers,
    executives,
    indexDescription,
    companyDescription,
    fundTopHoldings,
  } = quoteData;

  return (
    <div className={classes([!isAllowed && styles.contentBlur])}>
      {(indexDescription || companyDescription) && (
        <About quoteData={quoteData} />
      )}
      {isAllowed && (
        <>
          {Boolean(fundTopHoldings?.length) && (
            <TopHoldings topHoldings={fundTopHoldings as TopHolding[]} />
          )}
          {executives && <Executives people={executives} showHeadshot />}
          {boardMembers && (
            <BoardMembersContainer boardMembers={boardMembers} />
          )}
        </>
      )}
    </div>
  );
}
